import { Controller } from "stimulus";
import consumer from "channels/consumer";

const PRO_MIC_KEYWORDS = [
  "focusrite",
  "scarlett",
  "audient",
  "motu",
  "presonus",
  "universal audio",
  "apollo",
  "steinberg",
  "yamaha",
  "behringer",
  "go xlr",
  "goxlr",
  "rode",
  "rØde",
  "shure",
  "zoom",
  "tascam",
  "elgato",
  "wave",
  "apogee",
  "antelope",
  "ssl",
  "solid state logic",
  "sm7b",
  "sm58",
  "mv7",
  "at2020",
  "at2035",
  "atr",
  "nt1",
  "nt1-a",
  "podmic",
  "procaster",
  "blue yeti",
  "hyperx quadcast",
].map((s) => s.toLowerCase());

export default class extends Controller {
  connect() {
    // if (localStorage.hide_practices == "true") {
    this.show_join_recording_room_modal();
    // }
    subscription_id = $("[data-subscription-id]").attr("data-subscription-id");
    this.showCorrectDarkLightMode();
  }

  show_join_recording_room_modal(first_time = false) {
    // $("#best_practices_modal").remove();
    $("#join_modal").show();

    if (typeof AgoraRTC !== "undefined") {
      Room.check_browser();
      this.setEncodingOptions();
      this.bindEnterKey();
      this.tryConnect();
      //bug with ios15.1 iphone
      // if (Room.is_iOS()){
      client = AgoraRTC.createClient({ mode: "rtc", codec: "h264" });
      // } else {
      // client = AgoraRTC.createClient({ mode: "live", codec: "h264" });
      // }

      this.bindClientEvents();

      AgoraRTC.onAutoplayFailed = () => {
        console.log("AgoraRTC.onAutoplayFailed");

        AgoraRTC.onAudioAutoplayFailed = () => {
          if (isAudioAutoplayFailed) return;

          isAudioAutoplayFailed = true;
          const btn = document.createElement("button");
          btn.innerText =
            "Click here to allow browser to play video and audio.";
          btn.onclick = function () {
            isAudioAutoplayFailed = false;
            btn.remove();
          };
          btn.className = "p-4";
          if ($("#pre-local-player").length == 0) {
            Rollbar.error("onAudioAutoplayFailed error");
          } else {
            $("#pre-local-player").prepend(btn);
          }
        };
      };

      this.setBindings();
    } else {
      var that = this;
      setTimeout(() => {
        if (first_time) {
          that.show_join_recording_room_modal((first_time = false));
        } else {
          console.error("window.AgoraRTC not defined");
          Rollbar.error("window.AgoraRTC1_notdefined");
          $("#use_browser").show();
        }
      }, "1000");
    }
  }

  async tryConnect() {
    try {
      MediaRecorder.isTypeSupported;
      await Promise.all([
        Devices.loadSpeakers(),
        Devices.loadMics(),
        Devices.loadCameras(),
      ]);

      if (Room.is_iOS()) {
        await AgoraChannel.connectAgoraDevices();
        await LocalStream.update();
      } else {
        await LocalStream.update();
        await AgoraChannel.connectAgoraDevices();
      }

      // Restore saved preferences after tracks are established
      const savedMic = localStorage.getItem("iris_microphone");
      if (savedMic) {
        const micOpts = $("#test_microphone_setting, #microphone_setting")
          .first()
          .find("option");
        if ([...micOpts].some((o) => o.value === savedMic)) {
          Devices.switchMicrophone(savedMic);
        }
      }

      const savedCam = localStorage.getItem("iris_camera");
      if (savedCam) {
        const camOpts = $("#video_setting, #test_video_setting")
          .first()
          .find("option");
        if ([...camOpts].some((o) => o.value === savedCam)) {
          Devices.switchCamera(savedCam);
        } else {
          localStorage.removeItem("iris_camera");
        }
      }

      // const savedListening = localStorage.getItem("iris_listening");
      const micLabel = (
        $("#test_microphone_setting, #microphone_setting").val() || ""
      ).toLowerCase();
      const isProMic = PRO_MIC_KEYWORDS.some((kw) => micLabel.includes(kw));
      if (isProMic) {
        Room.disableNoiseReduction();
        // this._updateListeningToggle("Headphones");
      }
      $("#join_room").prop("disabled", false).html("Join Room");
      // &#8594;
    } catch (err) {
      if (
        err.toString().includes("PERMISSION_DENIED") ||
        err.toString().includes("Permission denied")
      ) {
        $("#no_permissions").show();
      } else if (
        err.toString().includes("MediaRecorder is unsupported") ||
        err.toString().includes("Can't find variable: MediaRecorder") ||
        err.toString().includes("Can't find variable MediaRecorder")
      ) {
        $("#use_browser").show();
      } else if (
        err.name === "NotSupportedError" ||
        err.toString().includes("NotSupportedError") ||
        err.toString().includes("Not supported")
      ) {
        console.error("NotSupportedError in tryConnect:", err);
        Rollbar.error("TRY_CONNECT_NOT_SUPPORTED", err);
        alert(
          "Your browser or system does not support video calling.\n\nPossible causes:\n• Outdated browser version\n• Missing audio/video drivers\n• Corporate security policies\n• Browser security settings\n\nPlease try:\n1. Update your browser to the latest version\n2. Update your operating system\n3. Try a different browser (Chrome, Edge, Firefox)\n4. Check with your IT administrator if on a work computer\n5. Email support@iris.fm for help",
        );
        $("#use_browser").show();
      } else {
        console.log("cant connect to join room");
        Rollbar.error(err);
        throw err;
      }
    }
  }

  bindEnterKey() {
    $(document).keypress(function (e) {
      if ($("#join_modal").length == 1 && (e.keycode == 13 || e.which == 13)) {
        $("#join_room").click();
      }

      if (e.target.id == "message" && (e.keycode == 13 || e.which == 13)) {
        e.preventDefault();
        $("#send_message_button").click();
      }
    });
  }

  setEncodingOptions() {
    if (typeof MediaRecorder === "undefined") {
      $("#use_browser").show();
      return;
    }
    try {
      // Build array of codecs to try, in order of preference
      const codecsToTry = [
        "video/webm;codecs=h264", // fastest: stream copied, no re-encoding
        "video/webm;codecs:h264",
        "video/mp4",
        "video/webm;codecs=vp9", // second: re-encodes but faster than vp8
        "video/webm;codecs:vp9",
        "video/webm;codecs=vp8", // slowest: avoid if possible
        "video/webm;codecs:vp8",
        "video/webm",
      ];

      // Find first supported codec
      for (let codec of codecsToTry) {
        if (MediaRecorder.isTypeSupported(codec)) {
          encoding_options = codec;
          console.log("Selected encoding codec: " + encoding_options);
          break;
        }
      }

      // Store fallback codecs for error recovery
      window.encoding_fallbacks = codecsToTry.filter(
        (codec) =>
          MediaRecorder.isTypeSupported(codec) && codec !== encoding_options,
      );

      if (
        !encoding_options ||
        !MediaRecorder.isTypeSupported(encoding_options)
      ) {
        console.error("CANT FIND A GOOD ENCODING CONFIG");
        Rollbar.error("NO_ENCODING");
        $("#use_browser").show();
      }
    } catch (err) {
      console.log(err.message);
      Rollbar.error("NO_ENCODING_B");
      $("#use_browser").show();
    }
  }

  bindClientEvents() {
    // Note: setClientRole is not needed in RTC mode - all users can publish/subscribe by default
    // Only use setClientRole when mode is "live" (broadcaster/audience model)

    client.on(
      "user-published",
      AgoraChannel.handleUserPublished.bind(AgoraChannel),
    );
    client.on(
      "user-unpublished",
      AgoraChannel.handleUserUnpublished.bind(AgoraChannel),
    );
    client.on(
      "connection-state-change",
      AgoraChannel.connectionStateChanged.bind(AgoraChannel),
    );
    client.on("user-joined", AgoraChannel.handleUserJoined.bind(AgoraChannel));
    client.on("user-left", AgoraChannel.handleUserLeft.bind(AgoraChannel));

    if ($("#is_host").length > 0) {
      client.on(
        "network-quality",
        AgoraChannel.handleLocalNetworkQuality.bind(AgoraChannel),
      );
    }

    Live.connect_client_events();
  }

  setBindings() {
    $(document).on("keydown", function (event) {
      if (event.ctrlKey && event.key == "m") {
        Room.toggleMic();
      }
    });

    $(".invite_role_type").on("change", function (e) {
      var url = $("#invite_url").val().split("?")[0];
      var host_token = $("#invite_url").attr("data-host-token");
      var producer_token = $("#invite_url").attr("data-producer-token");
      if (this.value == "Guest") {
        $("#invite_role").val("0");
        $("#invite_url").val(url);
      } else if (this.value == "Host") {
        $("#invite_url").val(url + "?t=" + host_token);
        $("#invite_role").val("1");
      } else if (this.value == "Producer") {
        $("#invite_url").val(url + "?t=" + producer_token);
        $("#invite_role").val("2");
      }
    });

    $("#video_setting, #test_video_setting").on("change", function (e) {
      Devices.switchCamera(this.value);
      localStorage.setItem("iris_camera", this.value);
    });

    $("#test_microphone_setting, #microphone_setting").on(
      "change",
      async function (e) {
        await Devices.switchMicrophone(this.value);
        localStorage.setItem("iris_microphone", this.value);
        const label = this.value.toLowerCase();
        if (PRO_MIC_KEYWORDS.some((kw) => label.includes(kw))) {
          if (options.noise_reduction !== false) {
            console.log("pro mic found: disable noise reduction");
            Room.disableNoiseReduction();
          }
        } else {
          if (options.noise_reduction !== true) {
            console.log("pro mic not found: enable noise reduction");
            Room.enableNoiseReduction();
          }
        }
      },
    );

    $("#test_speaker_setting, #speaker_setting").on("change", function (e) {
      Devices.switchSpeaker(this.value);
    });

    $(document).on("keyup", "#init_name_setting", function () {
      $("#name_setting").val(this.value);
      $("#form_attendee_name").val(this.value);
      Rails.fire($("#attendee_update_name_form")[0], "submit");
      // localStorage.setItem("iris_name", this.value);
    });

    $(document).on("keyup", "#name_setting", function () {
      $("#form_attendee_name").val(this.value);
      Rails.fire($("#attendee_update_name_form")[0], "submit");
      // localStorage.setItem("iris_name", this.value);
    });

    // $(document).on('click', '#stop_recording_button', function() {
    //   setTimeout(function(){
    //      $("#stop_recording_button").prop("disabled", true);
    //                           $("#stop_recording_button").css("opacity", "0.5");
    //                         $("#stop_recording_button span").text(" Stopping... ") }, 1);
    // });

    // only thing that works for some reason
    $("#record_button").click(async function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (producer_role && $(".player").length <= 1) {
        alert("You are the only person in the room and you are set as a producer. No audio or video will be recorded. Please wait for a host or guest to join before starting the recording.");
        $("#record_button")
          .html('<span class="h-2 w-2 rounded-full bg-white"></span> Record')
          .css("opacity", "1")
          .removeClass("pointer-events-none")
          .removeAttr("aria-disabled")
          .data("starting", false)
          .prop("disabled", false);
        return;
      }

      if (!client.channelName) {
        console.log("WAIT to check channel again");
        await new Promise((resolve) => setTimeout(resolve, 1000));
        if (!client.channelName) {
          alert(
            "You are still joining the channel. Please try again in a few seconds. \n\nIf this continues contact our support by emailing support@iris.fm.",
          );
          return;
        }
      }

      // Update UI
      $("#record_button").html(
        `<span class="h-2 w-2 rounded-full bg-white"></span> Starting...`,
      );
      $("#record_button").css("opacity", "0.5");
      setTimeout(function () {
        $("#record_button").prop("disabled", true);
      }, 1);

      // POST with retry to handle transient network errors (e.g. ERR_NETWORK_CHANGED)
      var url = $("#record_button").attr("href");
      var csrfToken = document.querySelector(
        'meta[name="csrf-token"]',
      )?.content;

      function startRecordingRequest(retries) {
        fetch(url + `&retries=${retries}`, {
          method: "POST",
          headers: {
            "X-CSRF-Token": csrfToken,
            Accept: "text/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
          credentials: "same-origin",
        })
          .then(function (response) {
            if (!response.ok)
              throw new Error("Server error: " + response.status);
            return response.text();
          })
          .then(function (js) {
            eval(js);
          })
          .catch(function (error) {
            if (retries > 0) {
              console.log(
                "Recording start failed, retrying... (" +
                  retries +
                  " attempts left)",
              );
              setTimeout(function () {
                startRecordingRequest(retries - 1);
              }, 1500);
            } else {
              console.error("Recording start failed after retries:", error);
              $("#record_button").prop("disabled", false);
              $("#record_button span").text("record");
              $("#record_button span").removeClass("text-gray-600");
              $("#record_button").css("opacity", "1");
              alert(
                "Unable to start recording due to a network issue. Please check your connection and try again.",
              );
            }
          });
      }

      startRecordingRequest(3);
    });

    // $(window).on('unload', function() {
    //   Rails.ajax({url: `/r/${$("[data-room-id]").attr("data-room-id")}/user_left.js?uid=${options.uid}`, type: "delete"})
    //   if ($("#is_host").length > 0){ Room.check_force_stop_recording() }
    //   if (local_media_stream){ local_media_stream.getTracks().forEach(track => track.stop()); }
    //   for (var trackName in localTracks) {
    //     var track = localTracks[trackName];
    //     if(track) {
    //       track.stop();
    //       track.close();
    //       localTracks[trackName] = undefined;
    //     }
    //   }
    //   client.leave();
    // });

    window.onbeforeunload = function (e) {
      console.log("UNLOAD");
      if (window.uploading) {
        e.preventDefault();
        e.returnValue =
          "A recording is currently in progress. Are you sure you want to leave?";
        return e.returnValue;
      }
      window.pageUnloading = true;

      // Flush the final MediaRecorder chunk into IndexedDB before tearing down the
      // hardware tracks. recorder.stop() synchronously fires ondataavailable with any
      // buffered data, queuing an IndexedDB write that may survive the page unload.
      if (window.uploading) {
        LocalStream.flushRecorderOnUnload();
      }

      const recordingId = $("#recording_id").attr("data-recording-id");
      const userLeftData = new FormData();
      userLeftData.append("uid", options.uid);
      if (recordingId) userLeftData.append("recording_id", recordingId);
      navigator.sendBeacon(`/r/${$("[data-room-id]").attr("data-room-id")}/user_left.js`, userLeftData);
      if ($("#is_host").length > 0) {
        Room.check_force_stop_recording();
      }
      if (local_media_stream) {
        local_media_stream.getTracks().forEach((track) => track.stop());
      }
      for (var trackName in localTracks) {
        var track = localTracks[trackName];
        if (track) {
          track.stop();
          track.close();
          localTracks[trackName] = undefined;
        }
      }
      client.leave();

      //     window.addEventListener("beforeunload", function (e) {
      //         if (!window.uploading) {  return undefined }
      //
      //         var confirmationMessage = 'We are still uploading your local HD recording. '
      //                                 + 'If you leave before saving, your recordings will be lost.';
      //
      //         (e || window.event).returnValue = confirmationMessage; //Gecko + IE
      //         return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
      //     });
    };
  }

  showCorrectDarkLightMode() {
    if (
      localStorage.theme === "dark" ||
      (!("theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
      document.querySelector("html").classList.add("dark");
      $(".light_button").hide();
      $(".dark_button").show();
    } else {
      document.querySelector("html").classList.remove("dark");
    }
  }

  joinRoom(event) {
    event.preventDefault();
    if (producer_role) {
      $("#join_modal").hide();
      $("#producer_check_modal").show();
    } else {
      Rails.ajax({
        url:
          `/r/${$("#room_id").attr("data-room-id")}/waiting_room_status.js?room_attendee_id=` +
          $("#attendee_id").val(),
        type: "get",
      });
    }
  }

  removeCustomMessage(event) {
    event.preventDefault();
    $("#custom_message_modal").remove();
  }

  joinRoomAsProducer() {
    Rails.ajax({
      url:
        `/r/${$("#room_id").attr("data-room-id")}/waiting_room_status.js?room_attendee_id=` +
        $("#attendee_id").val(),
      type: "get",
    });
  }

  async toggleVideo(event) {
    event.preventDefault();
    Room.toggleVideo();
  }

  // async updateEchoCancellation(event){
  //   options.echo_cancellation = $(event.target.parentElement).find("input").prop("checked");
  //   $("#toggleC").prop("checked", $(event.target.parentElement).find("input").prop("checked"))
  //   await LocalStream.update()
  //   if (localTracks.audioTrack) {
  //     if (client.uid){ await client.unpublish([localTracks.audioTrack]) }
  //     await localTracks.audioTrack.stop();
  //     await localTracks.audioTrack.close();
  //     localTracks.audioTrack = undefined;
  //   }
  //   localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack(Devices.microphone_config);
  //   if (client.uid){ await client.publish([localTracks.audioTrack]) }
  //
  // }

  async enableEchoCancellation(event) {
    Rails.ajax({
      url: `/${subscription_id}/attendee/${$("#attendee_id").val()}/enable_echo_cancellation.js?force=true`,
      type: "patch",
    });
    this._updateListeningToggle("Speakers");
    // localStorage.setItem("iris_listening", "Speakers");
  }

  async disableEchoCancellation(event) {
    Rails.ajax({
      url: `/${subscription_id}/attendee/${$("#attendee_id").val()}/disable_echo_cancellation.js?force=true`,
      type: "patch",
    });
    this._updateListeningToggle("Headphones");
    // localStorage.setItem("iris_listening", "Headphones");
  }

  _updateListeningToggle(activeLabel) {
    const activeClass =
      "listening-toggle-btn flex-1 rounded-lg px-3 py-2 text-xs font-semibold bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 shadow-sm border border-gray-300 dark:border-gray-800 flex items-center justify-center gap-1.5";
    const inactiveClass =
      "listening-toggle-btn flex-1 rounded-lg px-3 py-2 text-xs font-semibold text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white flex items-center justify-center gap-1.5";
    document.querySelectorAll(".listening-toggle-btn").forEach(function (btn) {
      btn.className =
        btn.dataset.label === activeLabel ? activeClass : inactiveClass;
    });
  }

  async toggleSpeakers(event) {
    var label = $("#speaker_setting").val();
    if ($("#speaker_setting").val() != "off") {
      label = "off";
    }
    Devices.switchSpeaker(label);
  }

  async toggleMic(event) {
    event.preventDefault();
    Room.toggleMic();
  }

  async testSpeaker(event) {
    var audio = $("#trumpet_audio")[0];
    if (currentSpeaker) {
      await audio.setSinkId(currentSpeaker.deviceId);
      $("#trumpet_audio")[0].play();
    } else {
      alert("No speakers found to play the sound test.");
    }
  }

  copyText(event) {
    event.preventDefault();
    var copyText = document.getElementById("invite_url");
    copyText.select();
    copyText.setSelectionRange(0, 99999); /*For mobile devices*/
    document.execCommand("copy");
    $("#copy_invite_url").text("copied!");
    setTimeout(function () {
      $("#copy_invite_url").text("copy");
    }, 5000);
  }

  toggleChat(event) {
    event.preventDefault();
    $(".popup_opened:not(#chat_dropdown)").hide();
    $("#chat_dropdown").toggle();
    $("#unseen_message_count").text("");
  }

  showInviteModal() {
    $("#invite_modal").show();
    var dark = document.documentElement.classList.contains("dark");
    $(".invite-role-radio:checked")
      .siblings(".invite-role-pill")
      .css(
        dark
          ? {
              "border-color": "#2f855a",
              "background-color": "#22543d",
              color: "#68d391",
            }
          : {
              "border-color": "#9ae6b4",
              "background-color": "#f0fff4",
              color: "#2f855a",
            },
      );
  }

  closeInviteModal() {
    $("#invite_modal").hide();
  }

  closeRecordingSettingsModal() {
    $("#recording_settings_modal").hide();
  }

  closeEchoNoiseModal() {
    $("#echo_noise_recommendations_modal").hide();
  }

  closeCantTranscribeModal() {
    $("#cant_transcribe_modal").hide();
  }

  openRoomPanel() {
    $(".popup_opened:not(#room_panel)").hide();
    $("#room_panel").toggle();
  }

  openRecordingSettings(event) {
    event.preventDefault();
    $("#recording_settings_modal").show();
  }

  openEchoNoiseRecommendations(event) {
    event.preventDefault();
    $("#echo_noise_recommendations_modal").show();
  }

  openCantTranscribe(event) {
    event.preventDefault();
    $("#cant_transcribe_modal").show();
  }

  openSettingsDiv() {
    $(".popup_opened:not(#settings_dropdown)").hide();
    $("#settings_dropdown").toggle();
  }

  toggleUserOptions(event) {
    $(".user_options").hide();
    $(event.target)
      .parents(".user_option_button")
      .find(".user_options")
      .toggle();
  }

  retryConnect() {
    $("#no_permissions").hide();
    this.tryConnect();
  }

  toggleRoleBadge(event) {
    event.preventDefault();
    const currentRole = $("#room_role").val();
    const newRole = currentRole === "Host" ? "Producer" : "Host";
    $("#room_role").val(newRole);
    const badge = document.getElementById("role_badge_text");
    if (badge) badge.textContent = newRole;
    var attendee_id = $("#attendee_id").val();
    if (newRole === "Producer") {
      producer_role = true;
      Rails.ajax({
        url: `/${subscription_id}/attendee/${attendee_id}/update_room_role.js?room_role_id=producer`,
        type: "patch",
      });
    } else {
      producer_role = false;
      Rails.ajax({
        url: `/${subscription_id}/attendee/${attendee_id}/update_room_role.js?room_role_id=host`,
        type: "patch",
      });
    }
  }

  selectRole(event) {
    event.preventDefault();
    const role = event.currentTarget.dataset.role;
    $("#room_role").val(role);
    const activeClass =
      "role-toggle-btn flex-1 rounded-lg px-3 py-2 text-sm font-semibold bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 shadow-sm border border-gray-300 dark:border-gray-800";
    const inactiveClass =
      "role-toggle-btn flex-1 rounded-lg px-3 py-2 text-sm font-semibold text-gray-600 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white";
    document.querySelectorAll(".role-toggle-btn").forEach(function (btn) {
      btn.className = btn.dataset.role === role ? activeClass : inactiveClass;
    });
    // Keep badge in sync when toggled via the Headphones/Speakers buttons
    const badge = document.getElementById("role_badge_text");
    if (badge) badge.textContent = role;
    // Headphones (Host) = echo cancellation off, Speakers (Producer) = echo cancellation on
    if (role === "Host") {
      this.disableEchoCancellation(null);
    } else {
      this.enableEchoCancellation(null);
    }
    this.switchRole(event);
  }

  switchRole(event) {
    event.preventDefault();
    var role_type = $("#room_role").val();
    var attendee_id = $("#attendee_id").val();

    if (role_type == "Producer") {
      producer_role = true;
      Rails.ajax({
        url: `/${subscription_id}/attendee/${attendee_id}/update_room_role.js?room_role_id=producer`,
        type: "patch",
      });
    } else {
      producer_role = false;
      Rails.ajax({
        url: `/${subscription_id}/attendee/${attendee_id}/update_room_role.js?room_role_id=host`,
        type: "patch",
      });
    }
  }

  async leave(event) {
    event.preventDefault();
    if (window.uploading) {
      if (
        !confirm(
          "A recording is currently in progress. Are you sure you want to leave?",
        )
      ) {
        return;
      }
    }

    // Stop the recorder before tearing down hardware tracks so the final
    // ondataavailable chunk is flushed into IndexedDB while the stream is still live.
    // stop_showing_now_recording() below will call stopRecording() again but that is
    // idempotent — recorder will already be undefined by then.
    if (window.uploading) {
      LocalStream.flushRecorderOnUnload();
    }

    if (local_media_stream) {
      local_media_stream.getTracks().forEach((track) => track.stop());
    }
    remoteUsers = {};
    $("#remote-playerlist").html("");
    await client.leave();
    for (var trackName in localTracks) {
      var track = localTracks[trackName];
      if (track) {
        track.stop();
        track.close();
        localTracks[trackName] = undefined;
      }
    }

    for (var trackName in screenTracks) {
      var track = screenTracks[trackName];
      if (track) {
        track.stop();
        track.close();
        screenTracks[trackName] = undefined;
      }
    }
    if (screenClient) {
      await screenClient.leave();
      screenClient = undefined;
    }
    Room.check_force_stop_recording();
    await Room.stop_showing_now_recording();
    const recordingId = $("#recording_id").attr("data-recording-id");
    const userLeftData = new FormData();
    userLeftData.append("uid", options.uid);
    if (recordingId) userLeftData.append("recording_id", recordingId);
    navigator.sendBeacon(`/r/${$("[data-room-id]").attr("data-room-id")}/user_left.js`, userLeftData);
    console.log("leaving room");
    window.location = $("#leave").attr("data-href");
  }

  switchLightDarkMode(event) {
    if ($(".dark_button").is(":visible")) {
      $("html").removeClass("dark");
      $(".dark_button").hide();
      $(".light_button").show();
      localStorage.theme = "light";
    } else {
      $("html").addClass("dark");
      $(".dark_button").show();
      $(".light_button").hide();

      localStorage.theme = "dark";
    }
  }

  dontShowTipsModal(event) {
    event.preventDefault();
    if ($("#practices_checkbox").is(":checked")) {
      localStorage.hide_practices = true;
    } else {
      localStorage.removeItem("hide_practices");
    }
  }

  async shareScreen(event) {
    event.preventDefault();
    if (options.share_uid == undefined) {
      var attendee_id = $("#attendee_id").val();
      Rails.ajax({
        url: `/${subscription_id}/attendee/${attendee_id}/screen_share_token.js`,
        type: "get",
        success: function (response) {
          Room.startScreenCall();
        },
      });
    } else {
      Room.startScreenCall();
    }
  }

  async stopShareScreen(event) {
    event.preventDefault();
    Room.stopShareScreen();
  }

  showViewOptions(event) {
    event.preventDefault();
    $(event.target).parent().find(".view_options").toggle();
  }

  maximizePlayer(event) {
    event.preventDefault();
    $(event.target).parent().find(".maximize_option").hide();
    $(event.target).parent().find(".minimize_option").show();

    $(".true_frame_option").show();
    $(".remove_true_frame_option").hide();
    var player_container = $(event.target).parents(".player");
    var uid = player_container.attr("id").replace("player-", "");
    FixVideos.maximize(uid);
    $(".view_options").hide();
  }

  minimizePlayer(event) {
    event.preventDefault();
    $(".view_options").hide();
    $(event.target).parent().find(".maximize_option").show();
    $(event.target).parent().find(".minimize_option").hide();

    $(".true_frame_option").show();
    $(".remove_true_frame_option").hide();
    FixVideos.setNormal();
  }

  showTrueFrame(event) {
    event.preventDefault();
    $(".view_options").hide();
    $(event.target).parent().find(".true_frame_option").hide();
    $(event.target).parent().find(".remove_true_frame_option").show();
    var player_container = $(event.target).parents(".player");
    var uid = player_container.attr("id").replace("player-", "");
    FixVideos.showTrueFrame(uid);
  }

  removeTrueFrame(event) {
    event.preventDefault();
    $(".view_options").hide();
    $(event.target).parent().find(".true_frame_option").show();
    $(event.target).parent().find(".remove_true_frame_option").hide();
    var player_container = $(event.target).parents(".player");
    var uid = player_container.attr("id").replace("player-", "");
    FixVideos.removeTrueFrame(uid);
  }

  showSettingsModal(event) {
    event.preventDefault();
    this.show_join_recording_room_modal();
  }

  closeErrorModal(event) {
    event.preventDefault();
    $("#error_modal").hide();
  }

  closeUploadingComplete(event) {
    event.preventDefault();
    $("#recording_finished").hide();
  }

  goToRecording(event) {
    event.preventDefault();
    var subscription_id = $("[data-subscription-id]").attr(
      "data-subscription-id",
    );
    var recording_id = $("#recording_id").attr("data-recording-id");
    console.log("going to recording");
    window.location.href = `/${subscription_id}/recordings/${recording_id}`;
  }

  cancelProducerMode(event) {
    event.preventDefault();
    $("#producer_check_modal").hide();
    $("#join_modal").show();
  }

  muteUser(event) {
    event.preventDefault();
    const row = $(event.target).parents(".user_row");
    if (!row.find(".mute_button").is(":visible")) return;
    var attendee_id = row.attr("id").replace("user-row-", "");
    Rails.ajax({
      url: `/${subscription_id}/attendee/${attendee_id}/mute.js?force_mute=true`,
      type: "patch",
    });
  }

  unMuteUser(event) {
    event.preventDefault();
    const row = $(event.target).parents(".user_row");
    if (!row.find(".unmute_button").is(":visible")) return;
    var attendee_id = row.attr("id").replace("user-row-", "");
    Rails.ajax({
      url: `/${subscription_id}/attendee/${attendee_id}/unmute.js?force_unmute=true`,
      type: "patch",
    });
  }

  turnOffCameraForUser(event) {
    event.preventDefault();
    const row = $(event.target).parents(".user_row");
    if (!row.find(".fa-video").is(":visible")) return;
    var attendee_id = row.attr("id").replace("user-row-", "");
    Rails.ajax({
      url: `/${subscription_id}/attendee/${attendee_id}/camera_off.js?force_cam_off=true`,
      type: "patch",
    });
  }

  turnOnCameraForUser(event) {
    event.preventDefault();
    const row = $(event.target).parents(".user_row");
    if (!row.find(".fa-video-slash").is(":visible")) return;
    console.log("force cam on");
    var attendee_id = row.attr("id").replace("user-row-", "");
    Rails.ajax({
      url: `/${subscription_id}/attendee/${attendee_id}/camera_on.js?force_cam_on=true`,
      type: "patch",
    });
  }

  forceToggleEchoCancellation(event) {
    event.preventDefault();
    const btn = $(event.currentTarget);
    var attendee_id = btn.parents(".user_row").attr("id").replace("user-row-", "");

    if (btn.find("span").hasClass("translate-x-3")) {
      Rails.ajax({
        url: `/${subscription_id}/attendee/${attendee_id}/disable_echo_cancellation.js?force=true`,
        type: "patch",
      });
    } else {
      Rails.ajax({
        url: `/${subscription_id}/attendee/${attendee_id}/enable_echo_cancellation.js?force=true`,
        type: "patch",
      });
    }
  }

  // forceDisableEchoCancellation(event){
  //   event.preventDefault()
  //   var attendee_id = $(event.target).parents(".user_row").attr("id").replace("user-row-", '')
  //   Rails.ajax({url: `/${subscription_id}/attendee/${attendee_id}/disable_echo_cancellation.js?force=true`, type: "patch"})
  //   $(event.target).parents(".user_row").find(".user_options").hide()
  // }

  forceToggleNoiseReduction(event) {
    event.preventDefault();
    const btn = $(event.currentTarget);
    var attendee_id = btn.parents(".user_row").attr("id").replace("user-row-", "");

    if (btn.find("span").hasClass("translate-x-3")) {
      Rails.ajax({
        url: `/${subscription_id}/attendee/${attendee_id}/disable_noise_reduction.js?force=true`,
        type: "patch",
      });
    } else {
      Rails.ajax({
        url: `/${subscription_id}/attendee/${attendee_id}/enable_noise_reduction.js?force=true`,
        type: "patch",
      });
    }
  }

  // forceDisableNoiseReduction(event){
  //   event.preventDefault()
  //   var attendee_id = $(event.target).parents(".user_row").attr("id").replace("user-row-", '')
  //   Rails.ajax({url: `/${subscription_id}/attendee/${attendee_id}/disable_noise_reduction?force=true`, type: "patch"})
  //   $(event.target).parents(".user_row").find(".user_options").hide()
  // }

  waitingRoomStatus(event) {
    var waiting_room_icon_div = $("#waiting_room_icon");
    var host_token = $("[data-host-role-token]").attr("data-host-role-token");
    if (waiting_room_icon_div.hasClass("fa-door-open")) {
      waiting_room_icon_div
        .removeClass("fa-door-open")
        .addClass("fa-door-closed");
      $("#waiting_room_status_disabled_message").hide();
      $("#waiting_room_status_enabled_empty_message").show();
      Rails.ajax({
        url:
          `/r/${$("#room_id").attr("data-room-id")}.js?waiting_room=true&host_token=` +
          host_token,
        type: "patch",
      });
    } else {
      waiting_room_icon_div
        .removeClass("fa-door-closed")
        .addClass("fa-door-open");
      $("#waiting_room_status_disabled_message").show();
      $("#waiting_room_status_enabled_empty_message").hide();
      Rails.ajax({
        url:
          `/r/${$("#room_id").attr("data-room-id")}.js?waiting_room=false&host_token=` +
          host_token,
        type: "patch",
      });
    }
  }

  changeRemoteMicrophones(event) {
    var mic = $(event.target).val();
    var attendee_id = $(event.target)
      .parents(".user_row")
      .attr("id")
      .replace("user-row-", "");
    if (attendee_id == $("#attendee_id").val()) {
      $("#mic-btn span").text(mic === "off" ? "Mic Off" : "Mic");
    }
    Rails.ajax({
      url: `/${subscription_id}/attendee/${attendee_id}/update_meta.js?microphone=${mic}&change_microphone=true`,
      type: "patch",
    });
  }

  changeRemoteCameras(event) {
    var camera = $(event.target).val();
    var attendee_id = $(event.target)
      .parents(".user_row")
      .attr("id")
      .replace("user-row-", "");
    Rails.ajax({
      url: `/${subscription_id}/attendee/${attendee_id}/update_meta.js?camera=${camera}&change_camera=true`,
      type: "patch",
    });
  }

  editRemoteCameras(event) {
    var attendee_id = $(event.target)
      .parents(".user_row")
      .attr("id")
      .replace("user-row-", "");
    if ($(event.target).hasClass("fa-chevron-circle-down")) {
      $("#user-row-" + attendee_id + " #remote_camera_settings").slideDown(100);
      $(event.target).removeClass("fa-chevron-circle-down");
      $(event.target).addClass("fa-chevron-circle-up");
    } else {
      $("#user-row-" + attendee_id + " #remote_camera_settings").slideUp(100);
      $(event.target).removeClass("fa-chevron-circle-up");
      $(event.target).addClass("fa-chevron-circle-down");
    }
  }

  editRemoteMicrophones(event) {
    var attendee_id = $(event.target)
      .parents(".user_row")
      .attr("id")
      .replace("user-row-", "");
    if ($(event.target).hasClass("fa-chevron-circle-down")) {
      $("#user-row-" + attendee_id + " #remote_microphone_settings").slideDown(
        100,
      );
      $(event.target).removeClass("fa-chevron-circle-down");
      $(event.target).addClass("fa-chevron-circle-up");
    } else {
      $("#user-row-" + attendee_id + " #remote_microphone_settings").slideUp(
        100,
      );
      $(event.target).removeClass("fa-chevron-circle-up");
      $(event.target).addClass("fa-chevron-circle-down");
    }
  }

  toggleShowingDevices(event) {
    var attendee_id = $(event.target)
      .parents(".user_row")
      .attr("id")
      .replace("user-row-", "");
    if ($(event.target).hasClass("fa-chevron-down")) {
      $("#user-row-" + attendee_id + " .devices").slideDown(200);
      $(event.target).removeClass("fa-chevron-down");
      $(event.target).addClass("fa-chevron-up");
    } else {
      $("#user-row-" + attendee_id + " .devices").slideUp(200);
      $(event.target).removeClass("fa-chevron-up");
      $(event.target).addClass("fa-chevron-down");
    }
  }

  showLiveModal(event) {
    $("#live_stream_modal").show();
  }

  enableLiveTranscriptions(event) {
    $("#live_transcript").css("display", "inline-block");
    if (Transcribe.running != true) {
      Transcribe.start();
    }
    $("#enable_live_transcription_button").hide();
    $("#disable_live_transcription_button").show();
  }

  disableLiveTranscriptions(event) {
    $("#live_transcript").hide();
    $("#enable_live_transcription_button").show();
    $("#disable_live_transcription_button").hide();
  }

  show_permissions(event) {
    $("#no_permissions").show();
  }

  closeLiveModal(event) {
    $("#live_stream_modal").hide();
  }

  streamToYoutube(event) {
    Live.streamToYoutube();
  }

  streamToTwitter(event) {
    Live.streamToTwitter();
  }

  streamToFacebook(event) {
    Live.streamToFacebook();
  }

  stopAllLiveStreaming(event) {
    Live.stopAllLiveStreaming();
  }
}
